/**
 * Labstep
 *
 * @module screens/EntityView/Index/Breadcrumb
 * @desc EntityView Index Breadcrumb
 */

import FolderBreadcrumb from 'labstep-web/components/Folder/Breadcrumb';
import { FolderType } from 'labstep-web/models/folder.model';
import type React from 'react';

export const EntityViewIndexBreadcrumb: React.FC = () => (
  <FolderBreadcrumb
    type={FolderType.entity_view}
    indexRoute="group_entity_views"
  />
);
